export enum AuditLogEventType {
	Create = 1,
	Read = 2,
	Update = 3,
	Delete = 4,
	UpdateSortOrder = 5,
	RecoverFromTrashCan = 6,
	Export = 7,
	ExecuteTask = 8,
	Initialized = 10,
	RestartWorkflow = 11,
	Cancel = 12,
	Completed = 14,
	Download = 15,
	Started = 17,
	DocumentCheckOut = 20,
	DocumentCheckin = 21,
	DocumentUndoCheckout = 23,
	BookmarkReplaced = 24,
	DirectLinkDownload = 25,
	DocumentPublished = 26,
	DocumentRemoved = 27,
	ChangedTo = 30,
	Succeeded = 41,
	Failed = 42,
	DocumentWrongMimeType = 43,
	TaskForwarded = 44,
	PeriodicRevisionPostPoned = 45,
	StepAllowAnonymousEnabled = 46,
	StepAllowAnonymousDisabled = 47,
	NotificationNotSent = 48,
	ExternalUserMailNotSent = 49,
	Printed = 50,
	Reset2FA = 51,
	Sent = 52,
	SentToExternalMail = 53,        
	Queued = 54,
	DraftSavedOrSent = 55,
	ApiRead = 56,
	WordReportGenerated = 57,
	DefaultEntityRemovedFromUserDueToRemovalEntity = 58,
	DefaultEntityRemovedFromUserDueToOrgChartModifications = 59,
	DefaultEntitySetForUser = 60,
	DefaultEntityRemovedFromUser = 61,
	DefaultEntitySetForUserDueToOrgChartModifications = 62,
	ChecklistAnswerUpdated = 63,
	Offline = 64,
	Unsynced = 65,
	Synced = 66
}